import { GenericService } from './generic.service';
import { EpisodeOfCareResponseData } from '@/models/episode-of-care/episode-of-care.model';

export class EpisodeOfCareService extends GenericService<EpisodeOfCareResponseData> {

  constructor() {
    super('v1/episodes-of-care');
  }
}
